<template>
    <b-container class="mb-3">
        <b-row cols="4" class="border-left border-right border-top bg-secondary text-white text-center border-1 p-2 rounded-top">
            <b-col>Queue</b-col>
            <b-col>Due within a week</b-col>
            <b-col>Due now</b-col>
            <b-col>Done
                <b-button class="btn-outline-light btn-sm float-right" @click="toggleCardLength()">
                    <span :class="toggleCardButtonFaceClass"></span>
                </b-button>
            </b-col>
        </b-row>
        <b-row cols="4" class="border-left border-right border-bottom rounded-bottom" border-variant="border-variant">
            <b-col v-if="columnOneData" class="border-right dcx-kanban-column">
                <kanban-item v-for="dataCheck in columnOneData" column="1" v-bind:key="dataCheck.id" :dataCheck="dataCheck" >{{dataCheck.name}}</kanban-item>
            </b-col>
            <b-col v-if="columnTwoData" class="border-right dcx-kanban-column">
                <kanban-item v-for="dataCheck in columnTwoData" column="2" v-bind:key="dataCheck.id" :dataCheck="dataCheck" >{{dataCheck.name}}</kanban-item>
            </b-col>
            <b-col v-if="columnThreeData" class="border-right dcx-kanban-column">
                <kanban-item v-for="dataCheck in columnThreeData" column="3" v-bind:key="dataCheck.id" :dataCheck="dataCheck" >{{dataCheck.name}}</kanban-item>
            </b-col>
            <b-col v-if="columnFourData" class="dcx-kanban-column">
                <kanban-item v-for="dataCheck in columnFourData" column="4" v-bind:key="dataCheck.id" :dataCheck="dataCheck" >{{dataCheck.name}}</kanban-item>
            </b-col>
        </b-row>
        <b-row class="px-0">
            <b-col class="w-100">
                <b-button class="btn-outline-light btn-sm float-right" @click="toggleCardLength()">
                    {{ toggleText}} <span :class="toggleTextIconClass"></span>
                </b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: "KanbanBoard",
    props: {
        researchStats: {
            type: Object,
            required: true,
        },
        cardLimit: {
            type: Number,
            default: 5,
            required: false,
        }
    },
    data () {
        return {
            limit: 5,
            texts: {
                kanbanCardLimitExpand : 'Show all cards',
                kanbanCardLimitCollapse : 'Collapse board',
            }
        }
    },
    mounted () {
        this.limit = this.cardLimit;
    },
    computed: {
        columnOneData: function () {
            return this.getColumnData(1)
                .sort((a, b) => new Date(a.nearestDueDate) - new Date(b.nearestDueDate))
                .slice(0, this.limit);
        },
        columnTwoData: function () {
            return this.getColumnData(2)
                .sort((a, b) => new Date(a.nearestDueDate) - new Date(b.nearestDueDate))
                .slice(0, this.limit);
        },
        columnThreeData: function () {
            return this.getColumnData(3)
                .sort((a, b) => new Date(a.nearestDueDate) - new Date(b.nearestDueDate))
                .slice(0, this.limit);
        },
        columnFourData: function () {
            return this.getColumnData(4)
                .sort((b, a) => new Date(a.recentCheckDate) - new Date(b.recentCheckDate))
                .slice(0, this.limit);
        },
        kanbanIsCollapsed: function () {
            return this.limit === this.cardLimit
        },
        toggleCardButtonFaceClass: function () {
            if (this.kanbanIsCollapsed) {
                return 'fa fa-plus';
            } else {
                return 'fa fa-minus';
            }
        },
        toggleTextIconClass: function () {
            if (this.kanbanIsCollapsed) {
                return 'fa fa-caret-down';
            } else {
                return 'fa fa-caret-up';
            }
        },
        toggleText: function () {
            if (this.kanbanIsCollapsed) {
                return this.texts.kanbanCardLimitExpand;
            } else {
                return this.texts.kanbanCardLimitCollapse;
            }
        },
    },
    methods:  {
        getColumnData: function (targetColumn) {
            let researchStats = this.researchStats;
            let mostSignificantColumn = 1;
            let columnData = [];
            if (!researchStats) {return []}
            // console.log('researchStats');
            Object.keys(researchStats).forEach((id, index) => {
                let brandData = researchStats[id];
                Object.keys(brandData).forEach((key, index2) => {
                    mostSignificantColumn = 1;
                    if (key === 'dataChecks') {
                        Object.keys(brandData['dataChecks']).forEach((countryId, index3) => {
                            let columnNo = brandData['dataChecks'][countryId]['kanban_column'];
                            /** Assign only to the most significant column ( 3 - 2 - 4 - 1 ) */
                            if (columnNo === 3) {
                                mostSignificantColumn = columnNo;
                            } else if (columnNo === 2 && (mostSignificantColumn === 4 || mostSignificantColumn === 1)) {
                                mostSignificantColumn = columnNo;
                            } else if (columnNo === 4 && mostSignificantColumn === 1) {
                                mostSignificantColumn = columnNo
                            }
                        });
                        if (mostSignificantColumn === targetColumn) {
                            // console.log('brand_id='+brandData['id']+' name=' + brandData['name'] + ' country='+countryId);
                            columnData.push(brandData);
                        }
                    }
                });
            });
            return columnData;
        },
        toggleCardLength: function () {
            if (this.kanbanIsCollapsed) {
                this.limit = 1000;
            } else {
                this.limit = this.cardLimit;
            }
        },
    }
}
</script>

<style scoped>

</style>
